export const CONTROLPANEL_URL = '/controlpanel'
export const DASHBOARD_URL = `${CONTROLPANEL_URL}/dashboard`
export const INBOX_URL = `${CONTROLPANEL_URL}/inbox`
export const ARTIST_PROFILES_URL = `${CONTROLPANEL_URL}/artist-profiles`
export const HELP_URL = `${CONTROLPANEL_URL}/help`
